package org.hs_soft.runmynesto.domain.model.home.options.export.option_credit_card


import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class GetAppConfig(
    @SerialName("creditCards")
    val creditCards: List<String?>?,
    @SerialName("__typename")
    val typename: String?
)